module.exports = __webpack_public_path__ + "img/hexisol.38859cce.jpg";